module.exports = __webpack_public_path__ + "img/meal.386898a9.svg";